var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExporticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.833 9L8.83301 9M1.33301 13.3886V5.05527M11.333 13.3886C11.333 14.3091 10.5868 15.0553 9.66634 15.0553H6.33301M11.333 5.05527C11.333 4.1348 10.5868 3.38861 9.66634 3.38861H6.33301M2.07517 15.5501L3.74184 16.6612C4.84943 17.3996 6.33301 16.6056 6.33301 15.2744V3.16947C6.33301 1.83831 4.84943 1.04432 3.74184 1.78272L2.07517 2.89383C1.61151 3.20294 1.33301 3.72333 1.33301 4.28058V14.1633C1.33301 14.7206 1.61151 15.2409 2.07517 15.5501Z",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExporticon);
export default __webpack_public_path__ + "static/media/exporticon.aa466dfd7dd3eee96467c9243f42a186.svg";
export { ForwardRef as ReactComponent };